var post_restrictions = ( function ( $ ) {

	var cookie_key = 'post_restrictions_country_code';

	var _init = function () {
		var $restricted_posts = $( '.restricted-post' );

		if ( $restricted_posts.length ) {
			_get_user_country_code().then( function ( country_code ) {
				console.log( 'country_code', country_code )

				$restricted_posts.each( function () {
					var $restricted_post = $( this );

					var restrictions = JSON.parse( decodeURIComponent( $restricted_post.data( 'restrictions' ) ) );

					console.log( 'restrictions', restrictions );

					if ( restrictions && Array.isArray( restrictions.countries ) ) {
						var can_access = false;

						if ( restrictions.type === 'blacklist' ) {
							can_access = !restrictions.countries.includes( country_code );
						} else if ( restrictions.type === 'whitelist' ) {
							can_access = restrictions.countries.includes( country_code );
						}

						var $notice = $restricted_post.parent().find( '#restrictions-notice' );

						if ( can_access ) {
							$restricted_post.removeClass( 'hidden' );

							$notice.remove();
						} else {
							$restricted_post.remove();

							$notice.text( 'Unfortunately, this content is not available in your region' );
						}
					}
				} );
			} );
		}
	};

	var _get_user_country_code = async function () {
		var country_code = $.cookie( cookie_key );

		if ( country_code && typeof country_code === 'string' ) {
			return country_code;
		}

		try {
			const ip_data      = await $.getJSON( 'https://ipapi.co/json/' );
			const country_code = ip_data && ip_data.country_code ? ip_data.country_code : null;

			if ( country_code && typeof country_code === 'string' ) {
				$.cookie( cookie_key, country_code, { expires: new Date( Date.now() + 30 * 60 * 1000 ), path: '/' } );

				return country_code;
			} else {
				throw new Error( 'country_code code not found in response' );
			}
		} catch ( error ) {
			console.log( 'IP API request failed: ' + error );

			return null;
		}
	}

	$( document ).ready( _init );

	return {};

} )( jQuery );

module.exports = post_restrictions;